var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import { Box, Button, CircularProgress, Stack, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Signature from '@uiw/react-signature';
var SignaturePad = forwardRef(function (_a, ref) {
    var questionId = _a.questionId, value = _a.value, onEmptyChange = _a.onEmptyChange, _b = _a.error, error = _b === void 0 ? false : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c, _d = _a.isUploading, isUploading = _d === void 0 ? false : _d;
    var _e = useState(false), hasDrawn = _e[0], setHasDrawn = _e[1];
    var signatureRef = useRef(null);
    // Expose methods via ref
    useImperativeHandle(ref, function () { return ({
        getSignatureFile: function () { return __awaiter(void 0, void 0, void 0, function () {
            var svgelm, clientWidth_1, clientHeight_1, data_1;
            return __generator(this, function (_a) {
                if (!signatureRef.current || !signatureRef.current.svg || !hasDrawn) {
                    return [2 /*return*/, null];
                }
                try {
                    svgelm = signatureRef.current.svg.cloneNode(true);
                    clientWidth_1 = signatureRef.current.svg.clientWidth;
                    clientHeight_1 = signatureRef.current.svg.clientHeight;
                    svgelm.removeAttribute('style');
                    svgelm.setAttribute('width', "".concat(clientWidth_1, "px"));
                    svgelm.setAttribute('height', "".concat(clientHeight_1, "px"));
                    svgelm.setAttribute('viewbox', "".concat(clientWidth_1, " ").concat(clientHeight_1));
                    data_1 = new XMLSerializer().serializeToString(svgelm);
                    // Create canvas and convert SVG to PNG
                    return [2 /*return*/, new Promise(function (resolve) {
                            var canvas = document.createElement('canvas');
                            var ctx = canvas.getContext('2d');
                            var img = new Image();
                            img.onload = function () {
                                canvas.width = clientWidth_1 || 0;
                                canvas.height = clientHeight_1 || 0;
                                ctx === null || ctx === void 0 ? void 0 : ctx.drawImage(img, 0, 0);
                                // Convert canvas to blob then to file
                                canvas.toBlob(function (blob) {
                                    if (blob) {
                                        var file = new File([blob], "signature-".concat(questionId, ".png"), { type: 'image/png' });
                                        resolve(file);
                                    }
                                    else {
                                        resolve(null);
                                    }
                                }, 'image/png');
                            };
                            img.onerror = function () {
                                console.error('Error loading image from SVG data');
                                resolve(null);
                            };
                            img.src = "data:image/svg+xml;base64,".concat(window.btoa(unescape(encodeURIComponent(data_1))));
                        })];
                }
                catch (error) {
                    console.error('Error getting signature file:', error);
                    return [2 /*return*/, null];
                }
                return [2 /*return*/];
            });
        }); },
        clear: function () {
            if (signatureRef.current) {
                signatureRef.current.clear();
            }
            setHasDrawn(false);
            onEmptyChange(true);
        },
        isEmpty: function () {
            return !hasDrawn && !value;
        }
    }); });
    var handlePointerUp = function () {
        if (!hasDrawn) {
            setHasDrawn(true);
            onEmptyChange(false);
        }
    };
    var handleClear = function () {
        if (signatureRef.current) {
            signatureRef.current.clear();
        }
        setHasDrawn(false);
        onEmptyChange(true);
    };
    return (_jsxs(Box, { children: [_jsx(Typography, __assign({ variant: "body2", sx: { mb: 1, fontWeight: 500 } }, { children: "Please sign below:" })), _jsxs(Box, __assign({ sx: {
                    border: '2px solid',
                    borderColor: error ? 'error.main' : 'divider',
                    borderRadius: 1,
                    mb: 2,
                    position: 'relative',
                    backgroundColor: 'background.paper',
                    opacity: disabled ? 0.6 : 1,
                    pointerEvents: disabled ? 'none' : 'auto'
                } }, { children: [_jsx(Signature, { ref: signatureRef, options: {
                            size: 4,
                            thinning: 0.5,
                            smoothing: 0.5,
                            streamline: 0.5
                        }, style: {
                            width: '100%',
                            height: '200px',
                            border: 'none'
                        }, onPointerUp: handlePointerUp }), isUploading && (_jsx(Box, __assign({ sx: {
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            backgroundColor: 'rgba(255, 255, 255, 0.8)',
                            borderRadius: 1
                        } }, { children: _jsx(CircularProgress, { size: 40 }) })))] })), _jsxs(Stack, __assign({ direction: "row", spacing: 2, alignItems: "center" }, { children: [_jsx(Button, __assign({ variant: "outlined", size: "small", onClick: handleClear, disabled: disabled || isUploading || (!hasDrawn && !value) }, { children: "Clear Signature" })), value && (_jsxs(Typography, __assign({ variant: "caption", color: "success.main", sx: { display: 'flex', alignItems: 'center', gap: 0.5 } }, { children: [_jsx(CheckCircleIcon, { fontSize: "small" }), "Signature saved"] }))), error && (_jsx(Typography, __assign({ variant: "caption", color: "error.main" }, { children: "Signature is required" })))] }))] }));
});
SignaturePad.displayName = 'SignaturePad';
export default SignaturePad;
